import "./Menu.scss"

export default {
	name: "eiis-menu",
  props: {
    header: String, background: String, alignment: String, items: Array, collapsed: Boolean
  },
	emits: ['updateView'],
	data() {
		return {
			active: "first",
			expanded: !this.collapsed
		}
	},
  computed: {
    classes: function () {
      let c = (this.alignment == "default" ? "" : this.alignment);
      // TODO c += (this.alignment == "center" ? "centered mx-auto" : this.alignment);
      return c;
    },
    menuItems: {
			get() {
				return Array(this.items);
			},
			set(i) {
				this.items = i;
			},
		}
  },
  methods: {
    isActive: function (i) {
			if (i.Name == this.active)
				return "active";
		},
    toggleMenu: function (i) {
			this.expanded = !this.expanded;
		},
    navigate: function (i) {
			this.$emit('updateView', i.view);
		}
  },
  template: `
    <div class="eiis-menu container" v-bind:class=classes>
			<div class="row flex-fill eiis-menu-header" @click="toggleMenu">
        <div class="col">
				  {{header}}
			  </div>
			  <div class="col-3">
        	<i class="fas fa-list-ul" v-if=!expanded></i>
				</div>
			</div>
      <nav class="nav flex-column" v-if=expanded>
        <li class="nav-item" v-for="item in items">
			    <div class="row nav-link eiis-menu-item" v-bind:class=isActive(item) @click="navigate(item)">
            <div class="col md-2">
              <i v-bind:class=item.icon v-if=item.icon></i>
              {{item.text}}
            </div>
        	</div>	
        </li>
      </nav>
      <slot></slot>
    </div>	
  `
}
